export const common = {
  border: `1px solid #EAECF0`,
  borderRadius: '8px',
};
